(function () {
'use strict';

angular
    .module('directives.placeholder', [])
    .directive('placeholder', directive);
        
directive.$inject = [];

function directive() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var placeholder = attrs.placeholder;
            if (placeholder) {
                $(element).placeholder();
            }
        }
    };
}
})();